import { Fun, Pair, mk_widget, Option } from "widgets-for-react";
import { List } from "immutable";
import React from 'react'
import { Breadcrumb } from "../../wordpress/types_and_parser/extra_types.mod";
import { ParsedNode } from "../../wordpress/types_and_parser/types.ext.gen";
import { ContentType } from "../../public_site.main.mod";


export const page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType> = breadcrumbs => blocks => {
  let page_type = window.location.pathname == '/' ? 'home' : 'page'
  return mk_widget({
    run: o => (
      <>
        <main className={`main main--default`}>
          <div className="main__inner gutter--m">
            <article className={`${page_type == 'home' ? 'page page--home' : 'page page--default'}`}>
              <div className="page__inner">
                  <div className="page__content">
                    {blocks.run(o)}
                  </div>
              </div>
            </article>
          </div>
        </main>
      </>
    )
  })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/page.mod.tsx